
import React, { useEffect, useState } from "react";
import MainLayout from "../layouts/MainLayout";
import Swal from 'sweetalert2';
import '../assets/styles/loader.css';
import '../assets/styles/pagination.css';
import { Select } from "antd";
import { useNavigate } from "react-router-dom";
import { BASE_API_URL } from "../services/baseServices";
import { fetchModuleScreens } from "../services/roleMenuServices";
import AddAlert from "../components/alerts/add";

export default function AlertsScreen() {

    const { Option } = Select;
    const [sessionUserData, setSessionUserData] = useState([]);
    const [moduleScreens, setModuleScreens] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [selectedModule, setSelectedModule] = useState(null);
    const [modules, setModules] = useState([]);
    const [actionName, setActionName] = useState('');
    const [addEnumLoading, setAddEnumLoading] = useState(false);
    const [actionEnums, setActionEnums] = useState([]);
    const [editRowId, setEditRowId] = useState(null);
    const [rowSelections, setRowSelections] = useState({});
    const navigate = useNavigate()

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setSessionUserData(userData);
        } else {
            navigate("/");
        }
    }, [navigate]);

    useEffect(() => {
        async function fetchActionEnums() {
            try {
                const response = await fetch(
                    `${BASE_API_URL}ADMINRoutes/CWIGetDDLItems?OrgId=0&UserId=0`
                );
                if (!response.ok) throw new Error("Network response was not ok");

                const data = await response.json();

                const filteredEnums = data.ResultData.filter(
                    (item) => item.DDLName === "ActionEnums"
                );

                const enumsFormatted = filteredEnums.map((item) => ({
                    label: item.DisplayValue,
                    value: item.ItemId,
                }));

                setActionEnums(enumsFormatted);
            } catch (error) {
                console.error("Failed to fetch ActionEnums:", error);
            }
        }

        fetchActionEnums();
    }, []);

    const fetchModulesData = async () => {
        try {
            const response = await fetch(`${BASE_API_URL}AdminRoutes/getModules`);
            if (response.ok) {
                const data = await response.json();
                const allModules = data.ResultData || [];

                setModules(allModules);
            } else {
                console.error("Failed to fetch menu data:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching menu data:", error.message);
        }
    };

    useEffect(() => {
        fetchModulesData();
    }, []);

    useEffect(() => {
        if (selectedModule) {
            getModuleScreens();
        }
    }, [selectedModule]);

    const getModuleScreens = async () => {
        setDataLoading(true);
        try {
            const data = await fetchModuleScreens(selectedModule);
            setModuleScreens(data);
        } catch (error) {
            console.error('Failed to load departments:', error);
        } finally {
            setDataLoading(false);
        }
    };

    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 5;
    const totalPages = moduleScreens?.length ? Math.ceil(moduleScreens?.length / recordsPerPage) : 0;

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = moduleScreens?.slice(indexOfFirstRecord, indexOfLastRecord);

    const getPaginationNumbers = () => {
        const visiblePages = [];
        if (totalPages <= 6) {
            for (let i = 1; i <= totalPages; i++) visiblePages.push(i);
        } else {
            if (currentPage <= 3) {
                visiblePages.push(1, 2, 3, "...", totalPages - 2, totalPages - 1, totalPages);
            }
            else if (currentPage > 3 && currentPage < totalPages - 2) {
                visiblePages.push(1, 2, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages - 1, totalPages);
            }
            else {
                visiblePages.push(1, 2, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            }
        }
        return visiblePages;
    };

    const handlePageClick = (page) => {
        if (page !== "...") setCurrentPage(page);
    };

    const handlePrevious = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handleClear = () => {
        setActionName('');
    };

    const maxEnumId = Math.max(...actionEnums.map((op) => op.value));
    const nextEnumId = maxEnumId + 1;

    const handleEdit = (menuId, existingIds) => {
        setEditRowId(menuId);
        setRowSelections((prev) => ({
            ...prev,
            [menuId]: existingIds, // initialize with current ActionIds
        }));
    };

    const handleSave = (menuId) => {
        const selectedIds = rowSelections[menuId] || [];
        console.log('Saving for:', menuId, 'with ActionIds:', selectedIds);

        // TODO: send to API here...

        // Exit edit mode
        setEditRowId(null);
    };

    const handleChange = (menuId, selectedValues) => {
        setRowSelections((prev) => ({
            ...prev,
            [menuId]: selectedValues,
        }));
    };

    return (
        <MainLayout>
            <div className="content">
                <div className="page-header">
                    <div className="add-item d-flex">
                        <div className="page-title">
                            <h4 className="fw-bold">Alerts</h4>
                            <h6>Manage your alerts</h6>
                        </div>
                    </div>
                    <ul className="table-top-head">
                        <li>
                            <button
                                className="btn btn-primary"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasRightAdd"
                                aria-controls="offcanvasRightAdd"
                            >Add Alert</button>
                        </li>
                        <li>
                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Refresh"><i className="ti ti-refresh"></i></a>
                        </li>
                    </ul>
                </div>
                <div className="row justify-content-evenly">
                    <div className="card col-12">
                        <div className="card-header border-0 pt-6">
                            <div className="card-title">
                                <div className="row w-100 align-items-center">
                                    <div className="col-md-4 mb-2">
                                        <Select
                                            showSearch
                                            placeholder="Choose Organization"
                                            className="w-100"
                                            value={selectedModule}
                                            onChange={(value) => setSelectedModule(value)}
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().includes(input.toLowerCase())
                                            }
                                        >
                                            {modules?.map((mod) => (
                                                <Option key={mod.Id} value={mod.Id}>
                                                    {mod.ModuleName}
                                                </Option>
                                            ))}
                                        </Select>
                                    </div>
                                </div>
                            </div>
                            <div className="card-toolbar">
                                <div className="d-flex justify-content-end" data-kt-customer-table-toolbar="base"></div>
                                <div className="d-flex justify-content-end align-items-center d-none" data-kt-customer-table-toolbar="selected">
                                    <div className="fw-bold me-5">
                                        <span className="me-2" data-kt-customer-table-select="selected_count"></span>Selected</div>
                                    <button type="button" className="btn btn-danger" data-kt-customer-table-select="delete_selected">Delete Selected</button>
                                </div>
                            </div>
                        </div>
                        <div className="card-body pt-0">
                            <div className="table-responsive">
                                <table className="table align-middle table-row-dashed fs-6 gy-5" id="kt_customers_table">
                                    <thead>
                                        <tr className="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                                            <th className="">S.No</th>
                                            <th className="min-w-125px">Alert Type</th>
                                            <th className="min-w-125px">Scheduled Date</th>
                                            <th className="min-w-125px">From Email</th>
                                            <th className="min-w-125px">To Email's</th>
                                            <th className="min-w-125px">Status</th>
                                            <th className="text-center">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className="fw-semibold text-gray-600">
                                        {dataLoading ? (
                                            <tr>
                                                <td colSpan="12" className="text-center">
                                                    <div className="container"></div>
                                                </td>
                                            </tr>
                                        ) : currentRecords && currentRecords.length > 0 ? (
                                            currentRecords.map((item, index) => {
                                                const itemId = item.Id || index;
                                                const isEditing = editRowId === itemId;
                                                const currentSelected =
                                                    rowSelections[itemId] ?? item.ActionIds?.split(',').map(Number) ?? [];

                                                return (
                                                    <tr key={itemId}>
                                                        <td>{(currentPage - 1) * recordsPerPage + index + 1}</td>
                                                        <td>
                                                            <a className="text-gray-800 text-hover-primary mb-1">{item.MenuName}</a>
                                                        </td>
                                                        <td>
                                                            <Select
                                                                mode="multiple"
                                                                showSearch
                                                                placeholder="Select Operation"
                                                                className="w-100"
                                                                disabled={!isEditing}
                                                                value={currentSelected}
                                                                onChange={(values) => handleChange(itemId, values)}
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                                                }
                                                            >
                                                                {actionEnums?.map((op) => (
                                                                    <Option key={op.value} value={op.value}>
                                                                        {op.label}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </td>
                                                        <td className="text-center">
                                                            {isEditing ? (
                                                                <i
                                                                    className="fa-solid fa-floppy-disk text-success me-2"
                                                                    title="Save"
                                                                    onClick={() => handleSave(itemId)}
                                                                    style={{ cursor: 'pointer' }}
                                                                ></i>
                                                            ) : (
                                                                <i
                                                                    className="fa-solid fa-pen text-primary me-2"
                                                                    title="Edit"
                                                                    onClick={() =>
                                                                        handleEdit(itemId, item.ActionIds?.split(',').map(Number) || [])
                                                                    }
                                                                    style={{ cursor: 'pointer' }}
                                                                ></i>
                                                            )}

                                                            <i
                                                                className="fa-regular fa-trash-can text-danger ms-2"
                                                                title="Delete"
                                                                // onClick={() => handleDelete(item)}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    transition: 'transform 0.2s',
                                                                }}
                                                                onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.2)')}
                                                                onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                            ></i>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan="12" className="text-center">
                                                    <p>No Data Available</p>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>

                                </table>
                                <div className="dt-paging paging_simple_numbers">
                                    <nav aria-label="pagination">
                                        <ul className="pagination">
                                            <li
                                                className={`dt-paging-button page-item ${currentPage === 1 ? "disabled" : ""}`}
                                            >
                                                <button
                                                    className="page-link previous"
                                                    role="link"
                                                    type="button"
                                                    aria-controls="kt_customers_table"
                                                    aria-disabled={currentPage === 1}
                                                    aria-label="Previous"
                                                    onClick={handlePrevious}
                                                >
                                                    <i className="previous"></i>
                                                </button>
                                            </li>

                                            {/* Page Numbers */}
                                            {getPaginationNumbers().map((page, index) => (
                                                <li
                                                    key={index}
                                                    className={`dt-paging-button page-item ${page === currentPage ? "active" : ""}`}
                                                >
                                                    <button
                                                        className="page-link"
                                                        role="link"
                                                        type="button"
                                                        aria-controls="kt_customers_table"
                                                        aria-current={page === currentPage ? "page" : undefined}
                                                        onClick={() => handlePageClick(page)}
                                                        disabled={page === "..."}
                                                    >
                                                        {page}
                                                    </button>
                                                </li>
                                            ))}

                                            {/* Next Button */}
                                            <li
                                                className={`dt-paging-button page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                            >
                                                <button
                                                    className="page-link next"
                                                    role="link"
                                                    type="button"
                                                    aria-controls="kt_customers_table"
                                                    aria-disabled={currentPage === totalPages}
                                                    aria-label="Next"
                                                    onClick={handleNext}
                                                >
                                                    <i className="next"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddAlert />
        </MainLayout>
    )
}